import { Component, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageDropdownComponent } from 'src/app/components/language-dropdown/language-dropdown.component';

@Component({
  selector: 'app-auth-page-layout',
  imports: [RouterModule, TranslateModule, LanguageDropdownComponent],
  templateUrl: './auth-page-layout.component.html',
  styleUrl: './auth-page-layout.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AuthPageLayoutComponent {
  @Input() variant: 'user' | 'admin' = 'user';
  @Input() homeLink = '/';

  @HostListener('mousedown', ['$event'])
  keepFieldFocusOnControlPress(event: MouseEvent) {
    const target = event.target as HTMLElement | null;
    const isTextField = !!target?.closest('input:not([type=checkbox]):not([type=radio]), textarea, select');
    if (target?.closest('button, a, label, input[type=checkbox]') && !isTextField) {
      event.preventDefault();
    }
  }
}
